import { SVGProps, Ref, forwardRef } from "react";

const SortUpIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Sort Up Icon"
    {...props}
  >
    <path d="m7 14 5-5 5 5H7Z" />
  </svg>
);

const ForwardRef = forwardRef(SortUpIcon);
export default ForwardRef;
